import { autoinject, Container } from "aurelia-dependency-injection";
import { AlertsJurisdictionModel } from "../models/alerts-jurisdiction";
import { AlertsJurisdictionView } from "./alerts-jurisdiction";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsModel } from "../models/alerts";
import { AlertsJurisdictionListView } from "./alerts-jurisdiction-list";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { AppUser } from "../../authentication/app-user";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-jurisdictions.html");

const dom = {
    THINKER: ".thinker",
    CONTENT: ".alert-content",
    ALERT_SIGNIN_OVERRIDE: ".alert-override-link",
    MESSAGE: ".alerts-message"
};

@backboneViewProperties({
    template: template
})
export class AlertsJurisdictionsView extends Marionette.LayoutView<AlertsModel> {
    private jurisdictionListRegion: Marionette.Region;
    private appEvents: Backbone.Events;
    private user: AppUser;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.user = options.user;
        this.setupModelListeners();
    }

    public regions(): any {
        const regions: any = {
            jurisdictionListRegion: "#alerts-jurisdiction-list-region"
        };
        return regions;
    }

    public async onShow() {
       this.updateInterface();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.ALERT_SIGNIN_OVERRIDE] = (e) => this.overrideLinkClick(e);
        return events;
    }

    private updateInterface() {
        this.$(dom.MESSAGE).empty();
        if (this.user.Sku.toLowerCase() === "free") {
            this.displayFreeUserMessage();
        } else if (this.user.Sku.toLowerCase() === "open") {
            this.displayOpenUserMessage();
        } else if (this.user.AuthenticatedByIp) {
            this.displayPersonalSignInMessage();
        } else if (this.user.isAcademicUser) {
            this.displayNoEmailMessage();
        } else if (!this.user.Email) {
            this.displayNoEmailMessage();
        } else {
            this.model.fetchJurisdictionData().then((data) => {
                this.model.JurisdictionAlerts.set(data);
                this.setupListRegion();
            }, () => {
                this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to retrieve jurisdiction alerts. Please try again.");
                this.$(dom.THINKER).toggle(false);
            }).catch((exception) => {
                if (!this.isDestroyed) {
                    this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to retrieve jurisdiction alerts. Please try again.");
                    this.$(dom.THINKER).toggle(false);
                }
            });
        }
    }

    private overrideLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const returnUrl = window.location.pathname;
        const signinUrl = `override?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private displayFreeUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p class="alerts-unavailable-message">Sorry, but alerts are only available to subscribed users. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayOpenUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p class="alerts-unavailable-message">Sorry, but alerts are not available in your subscriptions. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayPersonalSignInMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p class="alerts-unavailable-message">Sorry, but alerts are only available to signed in users. Please <a class="alert-override-link" href="override" data-command="signin" style="color:#fdb813">sign in as a personal user</a> to see your alerts.</p>`);
    }

    private displayNoEmailMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p class="alerts-unavailable-message">Sorry, but an email is required to set up alerts.</p>`);
    }

    private setupListRegion() {
        const listView = new AlertsJurisdictionListView({collection: this.model.JurisdictionAlerts});
        this.jurisdictionListRegion.show(listView);
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Loaded", this.onChangeLoaded);
        this.listenTo(this.user, "refresh", this.updateInterface);
    }

    private onChangeLoaded(model, property) {
        this.$(dom.THINKER).toggle(!property);
        this.$(dom.CONTENT).toggle(property);
    }

    private hideContent() {
        this.$(dom.THINKER).hide();
        this.$(dom.CONTENT).hide();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-jurisdictions.ts